import styled from 'styled-components';

const ArchiveItemWrapper = styled.div`
  position: relative;
  background: #f7f7f7;
`;

export default ArchiveItemWrapper;
